
import {Options, Vue} from "vue-class-component";

@Options({
  name: "SkeletonLoader"
})
export default class SkeletonLoader extends Vue {}
